import { Component, OnInit } from '@angular/core';
import { ChatService } from '../../services/chat.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NavParams, ViewController, Platform } from 'ionic-angular';

@Component({
    selector: 'daike-window',
    templateUrl: './daike-window.html',
})

export class DaikeWindowPage implements OnInit {
    daikeUrl;
    daikeKey;
    isWap;
    constructor(
        private chatService: ChatService,
        private sanitizer: DomSanitizer,
        public navParams: NavParams,
        private viewCtrl: ViewController,
        private platform: Platform,
    ) { }

    getQueryParams(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null)
            return decodeURIComponent(r[2]);
        return null;
    }

    ngOnInit() {
        this.daikeKey = this.navParams.get("key");
        this.daikeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.navParams.get("url"));
        // this.getDaiKeUrl();
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }
    // getDaiKeUrl() {
    //     this.chatService.getPayUrl().then(res => {
    //         if (res) {
    //             this.daikeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res);
    //         }
    //     }).catch(err => {
    //         console.log(err);
    //     })
    // }
}



// WEBPACK FOOTER //
// ./src/pages/daike-window/daike-window.ts